/**
 * @param {Editor} editor
 */
function register(editor) {
    function checkId(t) {
        return /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(t);
    }

    function anchorDialog(value = '', replaceTarget = false) {
        const initialValue = value.replace('bkmrk-cu-', '');
        editor.windowManager.open({
            title: 'Anchor',
            body: {
                type: 'panel',
                items: [
                    {
                        type: 'input',
                        name: 'anchor',
                        label: 'Id',
                        autofocus: true,
                    },
                ],
            },
            initialData: {
                anchor: initialValue,
            },
            buttons: [
                {
                    type: 'cancel',
                    text: 'Close',
                },
                {
                    type: 'submit',
                    text: 'Save',
                    primary: true,
                },
            ],
            onSubmit(api) {
                const data = api.getData();
                const id = `bkmrk-cu-${data.anchor}`;
                if (!checkId(id)) {
                    editor.windowManager.alert('Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.');
                    return;
                }
                editor.focus();
                editor.selection.collapse(true);
                if (replaceTarget) {
                    replaceTarget.setAttribute('id', id);
                } else {
                    editor.execCommand('mceInsertContent', false, editor.dom.createHTML('span', {
                        id,
                        contentEditable: false,
                        class: 'mce-item-anchor',
                    }));
                }
                api.close();
            },
        });
    }

    editor.ui.registry.addButton('anchorsPlugin', {
        icon: 'anchor',
        tooltip: 'Anchor',
        onAction() {
            anchorDialog('');
        },
    });

    editor.on('Click', e => {
        if (!e.target.id || e.target.id.lastIndexOf('bkmrk-cu-', 0) !== 0) return;
        anchorDialog(e.target.getAttribute('id'), e.target);
    });

    editor.on('PostProcess', e => {
        const temp = document.implementation.createHTMLDocument('temp');
        temp.body.innerHTML = e.content;
        const contentEditableEls = temp.querySelectorAll('[contentEditable]');
        for (let i = 0; i < contentEditableEls.length; i += 1) {
            contentEditableEls[i].removeAttribute('contentEditable');
        }
        e.content = temp.body.innerHTML;
    });

    editor.on('PreInit', () => {
        editor.on('SetContent', () => {
            const body = editor.getBody();
            const els = body.querySelectorAll('span[id^="bkmrk-cu-"]');
            for (let i = 0; i < els.length; i++) {
                els[i].setAttribute('contentEditable', false);
                if (!els[i].classList.contains('mce-item-anchor')) {
                    els[i].classList.add('mce-item-anchor');
                }
            }
        });
    });
}

/**
 * @return {register}
 */
export function getPlugin() {
    return register;
}
